import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Check, ShoppingCart, ArrowRight } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
export function AddedToCartModal() {
  const {
    isAddedModalOpen,
    closeAddedModal,
    lastAddedProduct,
    openCart
  } = useCartStore();
  if (!lastAddedProduct) return null;
  return <AnimatePresence data-id="element-10" data-mp="24mdb7zzhyu5m">
      {isAddedModalOpen && <>
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none" data-id="element-11" data-mp="1gzn96yn5ezl0">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeAddedModal} className="fixed inset-0 bg-brand-primary/40 backdrop-blur-sm pointer-events-auto" data-id="element-12" data-mp="1c1de0o1fbyze" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.97,
          y: 16
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.97,
          y: 16
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="w-full max-w-md bg-brand-bg shadow-subtle overflow-hidden flex flex-col pointer-events-auto relative z-10 border border-brand-primary/10" data-id="element-13" data-mp="y72t6hsjsoym">
              <div className="flex items-center justify-between px-8 py-6 border-b border-brand-primary/10" data-id="element-14" data-mp="tlbwpya8t2cb">
                <div className="flex items-center gap-3" data-id="element-15" data-mp="uad9kziokmz">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-brand-primary" data-id="element-16" data-mp="vv87bpqu5ld">
                    <Check className="w-3.5 h-3.5 text-white" strokeWidth={2} data-id="element-17" data-mp="5tn56k58whwf" />
                  </span>
                  <h2 className="text-lg font-serif font-normal text-brand-primary" data-id="element-18" data-mp="9x345n4seuca">Додано в кошик</h2>
                </div>
                <button onClick={closeAddedModal} className="p-2 hover:opacity-60 transition-opacity duration-200" data-id="element-19" data-mp="1la5gg5zusxqn">
                  <X className="w-4 h-4 text-brand-primary" strokeWidth={1.5} data-id="element-20" data-mp="1qbbdgg0jr75z" />
                </button>
              </div>

              <div className="px-8 py-8" data-id="element-21" data-mp="3iaru743qabqj">
                <div className="flex items-center gap-5 mb-10 pb-8 border-b border-brand-primary/10" data-id="element-22" data-mp="3i9qakb8ncgx7">
                  <img src={lastAddedProduct.img} alt={lastAddedProduct.title} className="w-16 h-16 object-cover border border-brand-primary/10" data-id="element-23" data-mp="3u11w771rht" />
                  <div data-id="element-24" data-mp="33m58mknicnqv">
                    <h3 className="font-serif font-normal text-brand-primary text-base leading-tight mb-2" data-id="element-25" data-mp="2ymsldysq5enr">
                      {lastAddedProduct.title}
                    </h3>
                    <p className="text-brand-muted font-light text-sm" data-id="element-26" data-mp="3ddrpoxmj1h1j">
                      {lastAddedProduct.price} грн
                    </p>
                  </div>
                </div>

                <div className="flex flex-col gap-3" data-id="element-27" data-mp="2ktjatut1in3n">
                  <button onClick={openCart} className="w-full py-4 bg-brand-primary hover:bg-brand-primaryHover text-white text-sm uppercase tracking-[0.15em] font-medium transition-colors duration-200 flex items-center justify-center gap-3" data-id="element-28" data-mp="2fx2o951hogso">
                    <ShoppingCart className="w-4 h-4" strokeWidth={1.5} data-id="element-29" data-mp="mellr9xm6wjw" />
                    Оформити замовлення
                  </button>
                  <button onClick={closeAddedModal} className="w-full py-4 bg-transparent hover:bg-brand-surfaceAlt text-brand-primary text-sm uppercase tracking-[0.15em] font-medium transition-colors duration-200 flex items-center justify-center gap-3 border border-brand-primary/15" data-id="element-30" data-mp="qd2u1wsrud2w">
                    Продовжити покупки
                    <ArrowRight className="w-4 h-4" data-id="element-31" data-mp="1a1lddxr3iw9o" />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}